/*
  Giardino cart drawer behaviour.

  Everything here is delegated from `document`, because the drawer's markup is
  replaced wholesale by cart.js / cart-drawer.js on every cart update — any
  listener bound to an element inside the drawer would be thrown away.
*/
(function () {
  'use strict';

  function track(button) {
    var recs = button.closest('[data-gdl-recs]');
    return recs && recs.querySelector('[data-gdl-recs-track]');
  }

  function step(el) {
    var card = el.querySelector('.gdl-recs__card');
    return card ? card.getBoundingClientRect().width + 10 : el.clientWidth;
  }

  document.addEventListener('click', function (event) {
    var prev = event.target.closest('[data-gdl-recs-prev]');
    var next = event.target.closest('[data-gdl-recs-next]');
    if (!prev && !next) return;

    var el = track(prev || next);
    if (!el) return;

    event.preventDefault();
    el.scrollBy({ left: next ? step(el) : -step(el), behavior: 'smooth' });
  });

  // `cart-drawer.js` calls renderContents() only when a line was just added,
  // so that is the moment to surface the "added" confirmation. Wait for the
  // element to be defined — this file may load before cart-drawer.js runs.
  customElements.whenDefined('cart-drawer').then(function () {
    var CartDrawer = customElements.get('cart-drawer');
    if (!CartDrawer || CartDrawer.prototype.__gdlPatched) return;

    var renderContents = CartDrawer.prototype.renderContents;
    CartDrawer.prototype.renderContents = function (parsedState) {
      renderContents.call(this, parsedState);

      var self = this;
      setTimeout(function () {
        var notice = self.querySelector('[data-gdl-added]');
        if (!notice) return;

        notice.hidden = false;
        notice.classList.remove('is-visible');
        // force a reflow so the transition replays on repeat adds
        void notice.offsetWidth;
        notice.classList.add('is-visible');

        clearTimeout(self.__gdlNoticeTimer);
        self.__gdlNoticeTimer = setTimeout(function () {
          notice.classList.remove('is-visible');
        }, 4000);
      });
    };
    CartDrawer.prototype.__gdlPatched = true;
  });
})();
